<mat-drawer-container>
  <mat-drawer-content>
    @if (showSpinner == true || training == null || user == null || labels == null || progress == null || status == null ||  comments == null) {
      <app-user-spinner
        >
        <mat-spinner class="spinner"></mat-spinner>
      </app-user-spinner>
    }
    @if (showSpinner == false) {
      <div class="webContainer">
        <div class="row justify-content-center">
          <div class = "goToTrainingDetails" (click) = "goToHomePage()">
            <img src = "./assets/icons/backIconWhite.png" alt = "Back button image">
            <span style = "vertical-align: middle; padding-left: 11px;">{{labels.lblTrainings}}</span>
          </div>
          @if (training.trngInfoImagePath) {
            <img style = "max-width: 100%;" src={{training.trngInfoImagePath}} alt = "Training info image">
          }
        </div>
        <div class="row" style="width:95%; margin: auto; margin-top: 3%; padding: 21px; background-color:white;">
          <div class="col-6" style="text-align: left">
            <h3 style="font-size: 35px;font-family: Lato, 'Alegreya Sans'; color: #0E0D35; font-weight: bold;">{{training.name}}</h3>
          </div>
          <div class="col-6" style="text-align: right;">

            <button
              [disabled]="this.testData?.isBlocked || disableTrainingButton"
              [class]="buttonStyle"
              [class.disableButton]="disableTrainingButton"
              style="width: 45%; background-color: #49D14F; border-radius: 11px; color: white;" mat-button
              class="mainBtn buttonContinue font" (click)="goToTraining(training, status)">@if (status == 1) {
              <span
              >{{labels.lblTrainingNotStarted.toUpperCase()}}</span>
            }
            @if (status == 2 && userTrainingData.successful) {
              <span>{{labels.lblTrainingStarted.toUpperCase()}}</span>
            }
            @if (status == 2 && !userTrainingData.successful) {
              <span>{{labels.lblTrainingStarted.toUpperCase()}}</span>
            }
            @if (status == 3 && !userTrainingData.successful) {
              <span>{{labels.lblTrainingStarted.toUpperCase()}}</span>
            }
            @if (status == 3 && userTrainingData.successful) {
              <span>{{labels.lblTrainingFinished.toUpperCase()}}</span>
            }
          </button>

          <br>
            <br>
            @if (disableTrainingButton) {
              <p>{{labels.lblNoUnits}}</p>
            }
              @if (!userTrainingData.successful && status != 1 && status != 2 && (training.testId)) {
                <button
                  [disabled]="this.testData?.isBlocked"
                  [class]="buttonStyle"
                  style="width: 45%; background-color: #49D14F; border-radius: 11px; color: white;" mat-button
                  class="mainBtn buttonContinue font" (click)="goToTest()">@if (status == 1) {
                  <span
                  >{{labels.lblTrainingNotStarted.toUpperCase()}}</span>
                }
                {{labels.lblStartQuiz}}
              </button>
            }
            @if (!userTrainingData.successful && !userTrainingData.surveyFlag && status == 3 && (training.surveyId)) {
              <button
                [disabled]="this.testData?.isBlocked"
                [class]="buttonStyle"
                style="width: 45%; background-color: red; border-radius: 11px; color: white;" mat-button
                class="mainBtn buttonContinue font" (click)="goToSurvey()">@if (status == 1) {
                <span
                >{{labels.lblTrainingNotStarted.toUpperCase()}}</span>
              }
                {{labels.lblGoBackToSurvey}}
              </button>
            }
          </div>
          <div class="col-12" style="margin-top: 3%;">
            <div class="row">
              @if (!training.isTestOnly) {
                <div class="col-3">
                  <div class = "row" style = "width: 100%; margin: auto;">
                    <div class = "col-5" [class.greyBckg]="status == 1" [class.navyBckg]="status == 2"
                         [style.padding-top]="status == 1 ? '25px' : '15px'"
                         [style.padding-bottom]="status == 1 ? '25px' : '10px'"
                      [class.greenBckg]="status == 3"
                                    style="-webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                        border-radius: 20px; margin: auto; ">
                      @if (status != 1) {
                        <div
                          class="col-12"
                          style="text-align: center;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;"  [style.color] = "status == 2 ? '#FFFFFF' : '#0E0D35'">
                          {{labels.lblStatus}}
                        </div>
                      }
                      <div class="col-12" style="text-align: center; color: white;font-family: Lato, 'Alegreya Sans';">
                        @if (status == 1) {
                          <span (click)="goToTraining(training, status)">{{labels.lblStart.toUpperCase()}}</span>
                        }
                        @if (status == 2) {
                          <span>{{labels.lblStarted.toUpperCase()}}</span>
                        }
                        @if (status == 3) {
                          <span>{{labels.lblFinished.toUpperCase()}}</span>
                        }
                        <div>{{status == 3 ? training.num_of_units : unitsOrder}}/{{training.num_of_units}}</div>
                      </div>
                    </div>
                    <div class = "col-2">
                    </div>
                    <div class = "col-5"
                         style="background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 20px; margin: auto; padding-top: 20px; padding-bottom: 20px; padding-right: 10px; padding-left: 10px;">
                      <div class="col-12"
                           style="text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                        {{labels.lblNumOfUnits}}
                      </div>
                      <div class="col-12" style="text-align: center; color: #799ACF;font-family: Lato, 'Alegreya Sans';">
                        {{training.num_of_units}}
                      </div>
                    </div>
                    <!--<div class = "col-5"
                                    style="background: #FFFFFF;
                        -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                        border-radius: 20px; margin: auto; padding-top: 25px; padding-bottom: 20px; padding-right: 10px; padding-left: 10px;">
                      <div class="col-12"
                        style="text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                        {{labels.lblNumOfSections}}
                      </div>
                      <div class="col-12" style="text-align: center; color: #799ACF;font-family: Lato, 'Alegreya Sans';">
                        {{training.sections.length}}
                      </div>
                    </div>-->
                  </div>
                  <div class = "row" style = "width: 100%; margin: auto; margin-top: 5%;">


                    <div class = "col-5"
                                style="background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 20px; margin: auto; padding-top: 20px; padding-bottom: 20px; padding-right: 10px; padding-left: 10px;">
                      <div class="col-12"
                        style="text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                        {{labels.lblduration}}
                      </div>
                      <div class="col-12" style="text-align: center; color: #799ACF;font-family: Lato, 'Alegreya Sans';">
                        {{training.duration}}
                      </div>
                    </div>
                    <div class = "col-7">
                    </div>
                  </div>
                </div>
              }
              <div class="col-9">
                <div class="row">
                  <!--<div class="col-12">
                    <h3 style="font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 20px; color: #120D26;">{{training.isTestOnly ? labels.aboutTest : labels.aboutTraining}}</h3>
                  </div>-->
                  <!--<div class="col-12">
                    <h5
                      style="font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 16.5px; color: #0E0D35; opacity: 0.5;">
                    {{training.description}}</h5>
                  </div>-->
                </div>
              </div>
            </div>
            <div class="row" style = "width: 100%; margin-top: 2.5%;">
                            <div class="col-6" style="background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; padding: 10px;">
                <div class="row">
                  <div class="col-xs-12 col-md-12 col-xl-6"
                    style="display: flex; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 14px; border-right: 1px solid #F1F1F1;">
                    <div>
                      @if (trainer?.profileImagePath) {
                        <img style="width: 50px; border-radius: 11px;" src="{{trainer?.profileImagePath}}" alt = "Trainer profile image">
                      }
                      @if (!trainer?.profileImagePath) {
                        <img style="width: 50px; border-radius: 11px;" src="{{defaultUserIcon}}" alt = "Trainer profile image">
                      }
                    </div>
                    <div style="padding-left: 10px; white-space: break-spaces; text-align: left">
                      {{trainer?.firstName}} {{trainer?.lastName}}
                      <!-- <br> -->
                       <p style="font-size: 12px; color: #799ACF">{{trainer.email}}</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-12 col-xl-6"  style="padding: 15px; margin: auto; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 13.5px;">
                    {{training.isTestOnly ? labels.lblTrainingAuthorTest : labels.lblTrainingAuthor}}
                  </div>
                </div>
                @for (coTrainer of coTrainers; track coTrainer) {
                  <div class="row my-2">
                    <div class="col-xs-12 col-md-12 col-xl-6 "
                      style="display: flex; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 14px; border-right: 1px solid #F1F1F1;">
                      <div>
                        @if (coTrainer?.profileImagePath) {
                          <img style="width: 50px; border-radius: 11px;" src="{{coTrainer?.profileImagePath}}" alt = "Trainer profile image">
                        }
                        @if (!coTrainer?.profileImagePath) {
                          <img style="width: 50px; border-radius: 11px;" src="{{defaultUserIcon}}" alt = "Trainer profile image">
                        }
                      </div>
                      <div style="padding-left: 10px; white-space: break-spaces; text-align: left"
                        matTooltip="{{coTrainer.about}}"
                        matTooltipClass="about-author"
                        aria-label="O autoru">
                        {{coTrainer?.firstName}} {{coTrainer?.lastName}}
                        <!-- <br> -->
                        <!-- <span style="font-size: 12px; color: #799ACF">{{trainer.email}}</span> -->
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-xl-6"  style="padding: 15px; margin: auto; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 13.5px;">
                      {{ labels.lblCoTrainingAuthor}}
                    </div>
                  </div>
                }
              </div>
              <div class="col-6">
                <div class="row">
                  @if (training.allowComments) {
                  <div class = "col-3" style = "background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
                    (click)="whatToDisplay('comments')">
                    <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        @if (!clickedComment) {
                          <img style = "width: 20px" src = "./assets/icons/forumGrey.png" alt = "forum icon">
                        }
                        @if (clickedComment) {
                          <img style = "width: 20px" src = "./assets/icons/forumGreen.png" alt = "forum icon">
                        }
                      </div>
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        <h5 [style.color] = "color1" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblComments}}</h5>
                      </div>
                    </div>
                  </div>
                  }
                  <div class = "col-3" style = "background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
                    (click)="whatToDisplay('documents')">
                    <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        @if (!clickedCouments) {
                          <img style = "width: 20px" src = "./assets/icons/docIconGrey.png" alt = "Doc icon">
                        }
                        @if (clickedCouments) {
                          <img style = "width: 20px" src = "./assets/icons/docIconGreen.png" alt = "doc icon">
                        }
                      </div>
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        <h5 [style.color] = "color2" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblDocuments}}</h5>
                      </div>
                    </div>
                  </div>
                  @if (!training.isTestOnly) {
                    <div class = "col-3" style = "background: #FFFFFF;
                      -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                      border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
                      (click)="whatToDisplay('training')">
                      <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
                        <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                          @if (!trngClicked) {
                            <img style = "width: 20px" src = "./assets/icons/trngIconGrey.png" alt = "training icon">
                          }
                          @if (trngClicked) {
                            <img style = "width: 20px" src = "./assets/icons/trngIconGreen.png" alt = "Training icon">
                          }
                        </div>
                        <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                          <h5 [style.color] = "color3" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblNumOfUnits}}</h5>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
          <!-- KOMENTARI -->
          @if (training.allowComments) {
          <div class="row" [style.display]="displayComments"
            style="width: 100%; margin: auto; margin-top: 3%; padding-top: 25px; border-top: 1px solid #E6E6E6;">
            <div>
              <h2 class="text-center">
                {{labels.lblComments}}
              </h2>
            </div>
             <div  style="width: 100%; margin: auto; margin-bottom: 15px;">
                        <div style="width: 100%; margin: auto; background: #FFFFFF;
                -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                border-radius: 16px;font-family: Lato, 'Alegreya Sans' !important;">
                <form (ngSubmit)="submitComment()" #insertForm="ngForm" style="width: 100%; margin: auto">
                  <div style="width: 90%; display: inline-block;">
                    <input matInput [ngModel]="user._id" name="userId" hidden>
                    <input matInput [ngModel]="user.firstName" name="firstName" hidden>
                    <input matInput [ngModel]="user.lastName" name="lastName" hidden>
                    <input matInput [ngModel]="user.email" name="email" hidden>
                    <mat-form-field appearance="none"
                      style="width:100%; margin: auto; color: #0E0D35 !important;">
                      <textarea matInput ngModel name="text" placeholder="{{labels.lblComment}}"
                                            style="color: #0E0D35 !important; font-family: Lato, 'Alegreya Sans' !important; padding-top: 5px !important;
                            padding-left: 10px !important; font-size: 17px;"></textarea>
                    </mat-form-field>
                  </div>
                  <div style="width: 10%; display: inline-block; text-align: center">
                    <img style="cursor: pointer; padding-bottom: 20px;" (click)="submitComment()"
                      src="./assets/icons/sendComment.png" alt = "Send comment icon">
                    </div>
                  </form>
                </div>
               <div class="comments" #scrollMe [scrollTop]="scrollMe.scrollHeight">
                  @for (c of comments; track c) {
                    <div class="comment font">
                       <!--<img class="commentImg" style = "width: 50px; margin-top: 15px;" src={{c?.imagePath}} alt="comment image">-->
                      <span class="headerText" style="display: inline-block; top: 4px; vertical-align: middle;">
                        <div>
                          <div class="col-12" style = "top: 5px;">
                            {{c.userId?.firstName}} {{c.userId?.lastName}}
                          </div>
                          <div class="col-12" style = "top: 3px;">
                            <span
                            style="color: #799ACF;font-family: Lato, 'Alegreya Sans'; font-size: 13.5px;">{{c.email}}</span>
                          </div>
                        </div>
                      </span>
                      <span style="float: right; margin: 7px; font-size: 12.5px">{{formatDate(c.time, 'dd/MM/yyyy hh:mm', 'en')}}</span><br>
                      <div style="margin: 10px; top: -11px; font-size: 15.5px; color: #0E0D35; opacity: 0.5;">
                      {{c.text}}</div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
            <!-- DOKUMENTI -->
            <div class="row" [style.display]="displayDocuments" style = "width: 100%; margin: auto; margin-top: 3%; padding-top: 25px; border-top: 1px solid #E6E6E6;">
              <div class="documents" >
                <div class="row" style="margin: auto;">
                  <!--<div class="col-6">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel class="expansionPanel" style = "padding: 0px;">
                        <mat-expansion-panel-header style = "padding: 10px;">
                          <div class="font1"><span
                            style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                        {{labels.lblAdminDocs}}</span></div>
                      </mat-expansion-panel-header>
                      @if (canDownloadTest && (training.testResults == true)) {
                        <div class="document">
                          <div class="documentDiv">
                            <span><img
                            src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText">
                            {{labels.lblTestResults}}</span>
                          </div>
                          <button mat-button class="buttonDocument"
                            (click)="downloadTestResults(training._id)"><img
                          src="./assets/icons/docIconBlue.png" alt = "DOc icon"></button>
                        </div>
                      }
                      @if (canDownloadSurvey && (training.surveyResults == true)) {
                        <div class="document"
                          >
                          <div class="documentDiv">
                            <span><img
                            src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText">
                            {{labels.lblSurveyResults}} </span>
                          </div>
                          <button mat-button class="buttonDocument"
                            (click)="downloadSurveyResults(training._id)"><img
                          src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                        </div>
                      }
                      @if (canDownloadStatement) {
                        <div class="document"
                          >
                          <div class="documentDiv">
                            <span><img
                            src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText"> {{labels.lblStatement}}
                            </span>
                          </div>
                          <button mat-button class="buttonDocument"
                            (click)="downloadStatement(training._id)"><img
                          src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                        </div>
                      }
                      @if ((canDownloadStatement == false) && (canDownloadSurvey == false) && (canDownloadTest == false)) {
                        <div style="margin-top: 15px; margin-left: 7px;"
                          >
                          <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}}
                          </span>
                        </div>
                      }
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>-->
                <div class="col-6">
                  <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel class="expansionPanel" style = "padding: 0px;">
                      <mat-expansion-panel-header style = "padding: 10px;">
                        <div class="font1"><span
                          style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                        {{labels.lblTrainingDocs}}</span></div>
                      </mat-expansion-panel-header>
                      @if (canDownloadTest && (training.testResults == true)) {
                        <div class="document">
                          <div class="documentDiv">
                            <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText">
                            {{labels.lblTestResults}}</span>
                          </div>
                          <button mat-button class="buttonDocument"
                                  (click)="downloadTestResults(training._id)"><img
                            src="./assets/icons/docIconBlue.png" alt = "DOc icon"></button>
                        </div>
                      }
                      @if (canDownloadCertificate && (training.certificateFlag == true)) {
                        <div class="document"
                        >
                          <div class="documentDiv">
                            <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText">
                            {{labels.lblCertificate}} </span>
                          </div>
                          <button mat-button class="buttonDocument"
                                  (click)="downloadCertificate(training._id)"><img
                            src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                        </div>
                      }
                      <!--@if (canDownloadStatement) {
                        <div class="document"
                        >
                          <div class="documentDiv">
                            <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText"> {{labels.lblStatement}}
                            </span>
                          </div>
                          <button mat-button class="buttonDocument"
                                  (click)="downloadStatement(training._id)"><img
                            src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                        </div>
                      }-->
                      @if ( (canDownloadSurvey == false) && (canDownloadTest == false)) {
                        <!--<div style="margin-top: 15px; margin-left: 7px;"
                        >
                          <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}}
                          </span>
                        </div>-->
                      }
                      @for (document of trainingDocuments; track document) {
                        <div class="document">
                          <div class="documentDiv">
                            <!-- <mat-icon style="color: #0E0D35; vertical-align: middle;"> attach_file</mat-icon> -->
                            <span><img
                            src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                            <span class="aligned-with-icon font headerText1">
                              {{document.docName}}
                            </span>
                          </div>
                          <a class="link" target="_blank" href={{document.docPath}}
                            cdkFocusInitial><img
                          src="./assets/icons/docIconBlue.png" alt = "Doc icon"></a>
                        </div>
                      }
                      @if (trainingDocuments.length == 0) {
                        <div style="margin-top: 15px; margin-left: 7px;"
                          >
                          <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}}
                            <a href="https://intranet.rgz.local/intranet/TemplateStandard.aspx?pageID=1667">https://intranet.rgz.local/intranet/TemplateStandard.aspx?pageID=1667</a>
                          </span>
                        </div>
                      }
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
                <!--<div class="col-6" style="margin-top: 3%;">
                  <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel class="expansionPanel" style = "padding: 0px;">
                      <mat-expansion-panel-header style = "padding: 10px;">
                        <div class="font1"><span
                          style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                        {{labels.lblAdditionalDocs}}</span></div>
                      </mat-expansion-panel-header>
                      <div>
                        @for (document of userDocuments; track document) {
                          <div class="document">
                            <div class="documentDiv">
                              <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText"> {{document.name}}
                              </span>
                            </div>
                            <a class="link" target="_blank" href={{document.path}}
                              cdkFocusInitial><img
                            src="./assets/icons/docIconBlue.png" alt = "Doc icon"></a>
                          </div>
                        }
                        @if (userDocuments.length == 0) {
                          <div style="margin-top: 15px; margin-left: 7px;"
                            >
                            <span class="aligned-with-icon font headerText1">
                            {{labels.lblNoDocuments}} </span>
                          </div>
                        }
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>-->
              </div>
            </div>
          </div>
          <!--OBLASTI -->
          <div class = "row" style = "width: 100%; margin: auto; margin-top: 3%; padding-top: 25px; border-top: 1px solid #E6E6E6;">
            @for (section of training.sections; track section) {
              <div style = "width: 100%;"  [style.display]="displaySections">
                <div class = "col-12 col-sm-6">
                  <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel style="margin-top: 10px; padding: 0px;" class = "expansionPanel">
                      <mat-expansion-panel-header style = "padding: 10px;">
                        <div class="sectionName font"><span
                          style="display:table-cell; padding-left: 10px; line-height: 30px;">
                        {{section.name}}</span></div>
                      </mat-expansion-panel-header>
                      @for (unit of section.units; track unit) {
                        <div (click)="goToUnit(unit)"
                          class="unitName font" style = "padding: 15px; cursor: pointer;">
                          <span class = "navyColor"
                            style = "width: 80%; vertical-align: middle; margin: 10px; float: left;">
                            <span style = "vertical-align: bottom;">
                              <img style = "width: 20px;" src = "/assets/icons/playCircleIcon.png" alt = "Unit icon">
                            </span>
                          {{unit.name}}</span>
                          <span style = "margin: 10px; float: right;">
                            <img style = "width: 20px;" src = "./assets/icons/unitIconNavy.png" alt = "unit icon">
                          </span>
                        </div>
                      }
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            }
          </div>
        </div>
    }
    <!-- mobile -->
    @if (showSpinner == false) {
      <div class="mobContainer">
        <div class="container2">
          <div class="info">
            <div class="row">
              <div class="col-11" style="margin: auto; text-align: center">
                <img style="width: 100%; height: 100%; object-fit: contain" src={{training.trngInfoImagePath}} alt = "Training image">
              </div>
            </div>
            <div class="row"
              style="width:95%; margin: auto; margin-top: 3%; padding: 21px; padding-left: 0px; background-color:white;">
              <div class="col-12" style="text-align: left">
                <h3 style="font-size: 35px;font-family: Lato, 'Alegreya Sans'; color: #0E0D35; font-weight: bold;">
                {{training.name}}</h3>
              </div>
            </div>
            @if (!training.isTestOnly) {
              <div class="col-12">
                <div style="display: flex;">
                  <div [class.greyBckg]="status == 1" [class.navyBckg]="status == 2"
                                [class.greenBckg]="status == 3" style="-webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                        border-radius: 20px; margin: auto; padding-top: 20px; padding-bottom: 20px;">
                    @if (status != 1) {
                      <div [style.color] = "status == 2 ? '#FFFFFF' : '#0E0D35'" class="col-12"
                        style="text-align: center;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                        {{labels.lblStatus}}
                      </div>
                    }
                    <div class="col-12" style="text-align: center; color: white;font-family: Lato, 'Alegreya Sans';">
                      @if (status == 1) {
                        <span>{{labels.lblStart.toUpperCase()}}</span>
                      }
                      @if (status == 2) {
                        <span>{{labels.lblStarted.toUpperCase()}}</span>
                      }
                      @if (status == 3) {
                        <span>{{labels.lblFinished.toUpperCase()}}</span>
                      }
                    </div>
                  </div>
                            <div style="background: #FFFFFF;
                        -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                        border-radius: 20px; margin: auto; padding-top: 20px; padding-bottom: 20px;">
                    <div class="col-12"
                      style="text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                      {{labels.lblNumOfSections}}
                    </div>
                    <div class="col-12" style="text-align: center; color: #799ACF;font-family: Lato, 'Alegreya Sans';">
                      {{training?.sections.length}}
                    </div>
                  </div>
                            <div style="background: #FFFFFF;
                        -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                        border-radius: 20px; margin: auto; padding-top: 20px; padding-bottom: 20px;">
                    <div class="col-12"
                      style="text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                      {{labels.lblNumOfUnits}}
                    </div>
                    <div class="col-12" style="text-align: center; color: #799ACF;font-family: Lato, 'Alegreya Sans';">
                      {{training.num_of_units}}
                    </div>
                  </div>
                            <div style="background: #FFFFFF;
                        -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                        border-radius: 20px; margin: auto; padding-top: 20px; padding-bottom: 20px;">
                    <div class="col-12"
                      style="text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 14px;">
                      {{labels.lblduration}}
                    </div>
                    <div class="col-12" style="text-align: center; color: #799ACF;font-family: Lato, 'Alegreya Sans';">
                      {{training.duration}}
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="row" style="margin-top: 7%; padding: 10px;">
              <!--<div class="col-12">
                <h3 style="font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 20px; color: #120D26;">{{training.isTestOnly ? labels.aboutTest : labels.aboutTraining}}
                </h3>
              </div>
              <div class="col-12">
                <h5
                  style="font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 16.5px; color: #0E0D35; opacity: 0.5;">
                {{training.description}}</h5>
              </div>-->
            </div>
            <div class="row" style="width:100%; margin: auto; padding: 10px;">
                        <div class="col-12" style="background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; margin-top: 7%; margin-bottom: 7%; padding: 10px;">
                <div class="row">
                  <div class="col-xs-12 col-lg-6"
                    style="display: flex; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 14px; border-right: 1px solid #F1F1F1;">
                    <div>
                      @if (trainer?.profileImagePath) {
                        <img style="width: 50px; border-radius: 11px;" src="{{ trainer?.profileImagePath}}" alt = "Trainer image">
                      }
                      @if (!trainer?.profileImagePath) {
                        <img style="width: 50px; border-radius: 11px;" src="{{ defaultUserIcon}}" alt = "Trainer image">
                      }
                    </div>
                    <div style="padding-left: 10px; text-align: left; font-size: 14px;">
                      {{trainer?.firstName}} {{trainer?.lastName}}
                      <!-- <br> -->
                      <!-- <span style="font-size: 12px; color: #799ACF">{{trainer.email}}</span> -->
                    </div>
                  </div>
                  <div class="col-xs-12 col-lg-6">
                    <h5
                      style="padding: 15px; margin: auto; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 12px;">
                    {{training.isTestOnly ? labels.lblTrainingAuthor : labels.lblTrainingAuthor}}</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="width:100%; margin: auto; padding: 10px;">
                    <div class="col-12" style="background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; margin-top: 7%; margin-bottom: 7%; padding: 10px;">
                @for (coTrainer of coTrainers; track coTrainer) {
                  <div class="row">
                    <div class="col-xs-12 col-lg-6"
                      style="display: flex; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 14px; border-right: 1px solid #F1F1F1;">
                      <div>
                        @if (coTrainer?.profileImagePath) {
                          <img style="width: 50px; border-radius: 11px;" src="{{ coTrainer?.profileImagePath}}" alt = "coTrainer image">
                        }
                        @if (!coTrainer?.profileImagePath) {
                          <img style="width: 50px; border-radius: 11px;" src="{{ defaultUserIcon}}" alt = "coTrainer image">
                        }
                      </div>
                      <div style="padding-left: 10px; text-align: left; font-size: 14px;">
                        {{coTrainer?.firstName}} {{coTrainer?.lastName}}
                      </div>
                    </div>
                    <div class="col-xs-12 col-lg-6">
                      <h5
                        style="padding: 15px; margin: auto; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: bold; font-size: 12px;">
                      {{labels.lblCoTrainingAuthor}}</h5>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-11" style="margin: auto;">
                @if (disableTrainingButton) {
                  <p>{{labels.lblNoUnits}}</p>
                }
                <button [disabled]="disableTrainingButton" [class]="buttonStyle"
                  style="background-color: #49D14F; border-radius: 11px; color: white; padding: 7px;"
                  [class.disableButton]="disableTrainingButton"
                  mat-button class="mainBtn buttonContinue font"
                  (click)="goToTraining(training, status)">@if (status == 1) {
                  <span
                  >{{labels.lblTrainingNotStarted}}</span>
                }
                @if (status == 2) {
                  <span>{{labels.lblTrainingStarted}}</span>
                }
                @if (status == 3) {
                  <span>{{labels.lblTrainingFinished}}</span>
                }</button>
              </div>
            </div>
            <div class="row" style="width: 100%; margin: auto; margin-top: 7%;">
              <div class="col-12">
                <div class="row" style = "width: 100%; margin: auto;">
                  @if (training.allowComments) {
                  <div class = "col-3" style = "background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
                    (click)="whatToDisplay('comments')">
                    <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        @if (!clickedComment) {
                          <img style = "width: 20px" src = "./assets/icons/forumGrey.png" alt = "Comment icon">
                        }
                        @if (clickedComment) {
                          <img style = "width: 20px" src = "./assets/icons/forumGreen.png" alt = "Comment icon">
                        }
                      </div>
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center; padding-left: 0px; padding-right: 0px;">
                        <h5 [style.color] = "color1" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblComments}}</h5>
                      </div>
                    </div>
                  </div>
                  }
                  <div class = "col-3" style = "background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
                    (click)="whatToDisplay('documents')">
                    <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        @if (!clickedCouments) {
                          <img style = "width: 20px" src = "./assets/icons/forumGrey.png" alt = "Doc icon">
                        }
                        @if (clickedCouments) {
                          <img style = "width: 20px" src = "./assets/icons/docIconGreen.png" alt = "Doc icon">
                        }
                      </div>
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center; padding-left: 0px; padding-right: 0px;">
                        <h5 [style.color] = "color2" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblDocuments}}</h5>
                      </div>
                    </div>
                  </div>
                  <div class = "col-3" style = "background: #FFFFFF;
                    -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
                    (click)="whatToDisplay('training')">
                    <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        @if (!trngClicked) {
                          <img style = "width: 20px" src = "./assets/icons/trngIconGrey.png" alt = "Training icon">
                        }
                        @if (trngClicked) {
                          <img style = "width: 20px" src = "./assets/icons/trngIconGreen.png" alt = "Training icon">
                        }
                      </div>
                      <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                        <h5 [style.color] = "color3" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblNumOfUnits}}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- KOMENTARI -->
            <div class="row"
              style="width: 100%; margin: auto; margin-top: 3%; padding-top: 25px; border-top: 1px solid #E6E6E6;">
              @if (training.allowComments) {
              <div [style.display]="displayComments" style="width: 100%; margin: auto; margin-bottom: 15px;">
                <div>
                  <h2 class="">
                    {{labels.lblContactSupport}}
                  </h2>
                </div>
                <div style="width: 100%; margin: auto; background: #FFFFFF;
                -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                border-radius: 16px;font-family: Lato, 'Alegreya Sans' !important;">
                  <form (ngSubmit)="submitComment()" #insertForm="ngForm"
                    style="width: 100%; margin: auto">
                    <div style="width: 90%; display: inline-block;">
                      <input matInput [ngModel]="user._id" name="userId" hidden>
                      <input matInput [ngModel]="user.firstName" name="firstName" hidden>
                      <input matInput [ngModel]="user.lastName" name="lastName" hidden>
                      <input matInput [ngModel]="user.email" name="email" hidden>
                      <mat-form-field appearance="none"
                        style="width:100%; margin: auto; color: #0E0D35 !important; opacity: 0.5">
                        <textarea matInput ngModel name="text" placeholder="{{labels.lblComment}}"
                                                style="color: #0E0D35 !important; opacity: 0.5; font-family: Lato, 'Alegreya Sans' !important; padding-top: 5px !important;
                            padding-left: 10px !important;"></textarea>
                      </mat-form-field>
                    </div>
                    <div style="width: 10%; display: inline-block; text-align: center">
                      <img style="cursor: pointer; padding-bottom: 20px;" (click)="submitComment()"
                        src="./assets/icons/sendComment.png" alt = "Comment icon">
                      </div>
                    </form>
                  </div>
                  <div class="comments" #scrollMe [scrollTop]="scrollMe.scrollHeight">
                    <!--@for (c of comments; track c) {
                      <div class="comment font">&ndash;&gt;
                        &lt;!&ndash; <img class="commentImg" src={{ defaultUserIcon}} alt="Comment icon"> &ndash;&gt;
                        <span class="headerText" style="display: inline-block; top: 4px">
                          <div class="row">
                            <div class="col-12">
                              {{c.fullName}}
                            </div>
                            <div class="col-12">
                              <span
                              style="color: #799ACF;font-family: Lato, 'Alegreya Sans'; font-size: 13.5px;">{{c.email}}</span>
                            </div>
                          </div>
                        </span>
                        <span style="float: right; margin:7px">{{c.time}}</span><br>
                        <div
                          style="margin: 10px; top: -11px; font-size: 24.5px; color: #0E0D35; opacity: 0.5;">
                      {{c.text}}</div>
                    </div>
                  }-->
                </div>
              </div>
              }
            </div>
            <!-- DOKUMENTI -->
            <div class="row" style="margin: auto;">
              <div class="documents" [style.display]="displayDocuments">
                <div class="row" style="margin: auto;">
                  <!--<div class="col-11" style="margin: auto;">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel class="expansionPanel">
                        <mat-expansion-panel-header>
                          <div class="font1"><span
                            style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                          {{labels.lblAdminDocs}}</span></div>
                        </mat-expansion-panel-header>
                        @if (canDownloadTest && (training.testResults == true)) {
                          <div class="document"
                            >
                            <div class="documentDiv">
                              <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText">
                              {{labels.lblTestResults}}</span>
                            </div>
                            <button mat-button class="buttonDocument"
                              (click)="downloadTestResults(training._id)"><img
                            src="./assets/icons/docIconBlue.png" alt = "DOc icon"></button>
                          </div>
                        }
                        @if (canDownloadSurvey && (training.surveyResults == true)) {
                          <div class="document"
                            >
                            <div class="documentDiv">
                              <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText">
                              {{labels.lblSurveyResults}} </span>
                            </div>
                            <button mat-button class="buttonDocument"
                              (click)="downloadSurveyResults(training._id)"><img
                            src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                          </div>
                        }
                        @if (canDownloadStatement) {
                          <div class="document"
                            >
                            <div class="documentDiv">
                              <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText">
                              {{labels.lblStatement}} </span>
                            </div>
                            <button mat-button class="buttonDocument"
                              (click)="downloadStatement(training._id)"><img
                            src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                          </div>
                        }
                        @if ((canDownloadStatement == false) && (canDownloadSurvey == false) && (canDownloadTest == false)) {
                          <div style="margin-top: 15px; margin-left: 7px;"
                            >
                            <span class="aligned-with-icon font headerText1">
                            {{labels.lblNoDocuments}} </span>
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>-->
                  <div class="col-11" style="margin: auto; margin-top: 5%;">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel class="expansionPanel">
                        <mat-expansion-panel-header>
                          <div class="font1"><span
                            style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                          {{labels.lblTrainingDocs}}</span></div>
                        </mat-expansion-panel-header>
                        @if (canDownloadTest && (training.testResults == true)) {
                          <div class="document"
                          >
                            <div class="documentDiv">
                              <span><img
                                src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText">
                              {{labels.lblTestResults}}</span>
                            </div>
                            <button mat-button class="buttonDocument"
                                    (click)="downloadTestResults(training._id)"><img
                              src="./assets/icons/docIconBlue.png" alt = "DOc icon"></button>
                          </div>
                        }
                        @if (canDownloadCertificate && training.certificateFlag) {
                          <div class="document"
                          >
                            <div class="documentDiv">
                              <span><img
                                src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText">
                              {{labels.lblCertificate}} </span>
                            </div>
                            <button mat-button class="buttonDocument"
                                    (click)="downloadCertificate(training._id)"><img
                              src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                          </div>
                        }
                        <!--@if (canDownloadStatement) {
                          <div class="document"
                          >
                            <div class="documentDiv">
                              <span><img
                                src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText">
                              {{labels.lblStatement}} </span>
                            </div>
                            <button mat-button class="buttonDocument"
                                    (click)="downloadStatement(training._id)"><img
                              src="./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                          </div>
                        }-->
                        @for (document of trainingDocuments; track document) {
                          <div class="document">
                            <div class="documentDiv">
                              <!-- <mat-icon style="color: #0E0D35; vertical-align: middle;"> attach_file</mat-icon> -->
                              <span><img
                              src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                              <span class="aligned-with-icon font headerText1">
                              {{document.docName}} </span>
                            </div>
                            <a class="link" target="_blank" href={{document.docPath}}
                              cdkFocusInitial><img
                            src="./assets/icons/docIconBlue.png" alt = "Doc icon"></a>
                          </div>
                        }
                        @if (trainingDocuments.length == 0) {
                          <div style="margin-top: 15px; margin-left: 7px;"
                            >
                            <span class="aligned-with-icon font headerText1">
                            {{labels.lblNoDocuments}} </span>
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                  <!--<div class="col-11" style="margin: auto; margin-top: 5%;">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel class="expansionPanel">
                        <mat-expansion-panel-header>
                          <div class="font1"><span
                            style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                          {{labels.lblAdditionalDocs}}</span></div>
                        </mat-expansion-panel-header>
                        <div>
                          @for (document of userDocuments; track document) {
                            <div class="document">
                              <div class="documentDiv">
                                <span><img
                                src="./assets/icons/attachmentIcon.png" alt = "Attachment icon"></span>
                                <span class="aligned-with-icon font headerText">
                                {{document.name}} </span>
                              </div>
                              <a class="link" target="_blank" href={{document.path}}
                                cdkFocusInitial><img
                              src="./assets/icons/docIconBlue.png" alt = "Doc icon"></a>
                            </div>
                          }
                          @if (userDocuments.length == 0) {
                            <div style="margin-top: 15px; margin-left: 7px;"
                              >
                              <span class="aligned-with-icon font headerText1">
                              {{labels.lblNoDocuments}} </span>
                            </div>
                          }
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>-->
                </div>
              </div>
            </div>
            <!--OBLASTI -->
            <div class = "row" style = "width: 100%; margin: auto; margin-top: 3%; padding-top: 25px; border-top: 1px solid #E6E6E6;">
              @for (section of training.sections; track section) {
                <div style = "width: 100%;"  [style.display]="displaySections">
                  <div class = "col-12 col-sm-6">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel style="margin-top: 10px; padding-top: 5px; padding-bottom: 5px;" class = "expansionPanel">
                        <mat-expansion-panel-header>
                          <div class="sectionName font"><span
                            style="display:table-cell; padding-left: 10px;">
                          {{section.name}}</span></div>
                        </mat-expansion-panel-header>
                        @for (unit of section.units; track unit) {
                          <div
                            class="unitName font"style = "padding: 15px;">
                            <span class = "navyColor"
                              style="width: 80%; vertical-align: middle; margin: 10px; float: left;">
                              <span style = "vertical-align: bottom;">
                                <img style = "width: 20px;" src = "./assets/icons/playCircleIcon.png" alt = "Unit icon">
                              </span>
                            {{unit.name}}</span>
                            <span style = "margin: 10px; float: right;">
                              <img style = "width: 20px;" src = "./assets/icons/unitIconNavy.png" alt = "Unit icon">
                            </span>
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </mat-drawer-content>
</mat-drawer-container>
